import { TimeSignal } from 'graphql/types';

export const UNCATEGORIZED_GROUP_KEY = 'UNCATEGORIZED-GROUP';

export interface NotesGroupByStrategy {
  generateGroups(notes: TimeSignal[]): Record<string, TimeSignal[]>;
}

export class NotesGroupBySorter {
  private strategy: NotesGroupByStrategy;

  constructor(strategy: NotesGroupByStrategy) {
    this.strategy = strategy;
  }

  generateGroups(notes: TimeSignal[]): Record<string, TimeSignal[]> {
    return this.strategy.generateGroups(notes);
  }
}
